module.exports = __webpack_public_path__ + "static/img/kkry_pc.4415019.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kkry_pc.gif
// module id = 9j4Z
// module chunks = 10